export default __webpack_public_path__ + "static/dwtc-logo-white-5204228bf55aa2afa3d5638ad61c0f19.png";